const stateKeys = [
  'availablePackages',
  'packages',
  'terms',
  'purchase_id',
  'hasMonitoring',
  'hasHemPackage'
]

export const state = () => ({ availablePackages: [] })

export const mutations = {
  setAvailablePackages(state, availablePackages) {
    state.availablePackages = availablePackages
  }
}

export const actions = {
  clearStorage(state) {
    for (let i = 0; i < stateKeys.length; i++) {
      if (
        stateKeys[i] !== 'hasMonitoring' &&
        stateKeys[i] !== 'hasHemPackage'
      ) {
        this.$storage.removeUniversal(stateKeys[i])
      }
    }
    state.availablePackages = []
  },
  async discardPurchaseInfo({ dispatch }) {
    await dispatch('clearStorage')
    await this.$storage.removeUniversal('purchaseData')
  },
  getPackage(_, packageId) {
    const packages = this.$storage.getUniversal('packages') || []
    return packages.filter((myPackage) => myPackage.id === packageId)[0]
  },
  async getPackages(_, installationId) {
    const result = await this.$marlonApi.listPackages(installationId)
    const cashbackPackages = result.cashback.map((p) => {
      p.isCashback = true
      return p
    })

    return {
      ...result,
      free: result.free,
      cashback: cashbackPackages
    }
  },
  setPackages(_, packages) {
    this.$storage.setUniversal('packages', packages)
  },
  getTerms() {
    return this.$storage.getUniversal('terms')
  },
  setTerms(_, terms) {
    this.$storage.setUniversal('terms', terms)
  },
  getHasMonitoring() {
    return this.$storage.getUniversal('hasMonitoring')
  },
  setHasMonitoring(_, hasHemPackageAvailable) {
    this.$storage.setUniversal('hasMonitoring', hasHemPackageAvailable)
  },
  getHasHemPackage() {
    this.$storage.getUniversal('hasHemPackage')
  },
  setHasHemPackage(_, hemPackage) {
    this.$storage.setUniversal('hasHemPackage', hemPackage)
  },
  setPurchaseData(_, purchaseData) {
    this.$storage.setUniversal('purchaseData', purchaseData)
  }
}
